import { BigNumber } from 'bignumber.js';

// default settings to be used for BigNumber
const DEFAULT_BIGNUMBER_CONFIG: BigNumber.Config = {
  DECIMAL_PLACES: 27,
  ROUNDING_MODE: BigNumber.ROUND_HALF_UP,
};

/** Format decimal to percentage
 * @param number input number
 * @param decimalPlaces Javascript limit for floating point mantissa is between 15-17 digits (maximum is 15 digits)
 * @param config Configure BigNumber settings
 * @returns "`result`%" as string
 */
export const formatPercent = (
  number: number,
  decimalPlaces?: number,
  config: BigNumber.Config = DEFAULT_BIGNUMBER_CONFIG
): string => {
  if (decimalPlaces && decimalPlaces > 15) {
    throw RangeError(
      'Javascript limit for floating point mantissa is between 15-17 digits (maximum is 15 digits)'
    );
  }

  BigNumber.set(config);

  let value = BigNumber(number).times(100);
  return `${decimalPlaces ? value.toFixed(decimalPlaces) : value.toString()}%`;
};

/**
 * Divide with high precision numbers
 * @param dividend input number
 * @param divisor number to divide `dividend` by
 * @param config Configure BigNumber settings
 * @returns result as number
 */
export const divideWithHighPrecisionNumbers = (
  dividend: number,
  divisor: number,
  config: BigNumber.Config = DEFAULT_BIGNUMBER_CONFIG
): number => {
  BigNumber.set(config);

  return BigNumber(dividend).dividedBy(divisor).toNumber();
};

/**
 * Multiply with high precision numbers
 * @param multiplicand
 * @param multiplier
 * @param config Configure BigNumber settings
 * @returns result as number
 */
export const multiplyWithHighPrecisionNumbers = (
  multiplicand: number,
  multiplier: number,
  config: BigNumber.Config = DEFAULT_BIGNUMBER_CONFIG
): number => {
  BigNumber.set(config);

  return BigNumber(multiplicand).times(multiplier).toNumber();
};

export const formatToPercent = (num: number): string => {
  return `${((Math.round(num * 10000) / 10000) * 100).toFixed(2)}%`;
};

export const roundWithHighPrecision = (num: number) => {
  return divideWithHighPrecisionNumbers(
    Math.round(multiplyWithHighPrecisionNumbers(num, 100000000)),
    100000000
  );
};
